package game

import com.soywiz.korge.render.BatchBuilder2D
import com.soywiz.korge.render.RenderContext
import com.soywiz.korge.render.Texture
import com.soywiz.korge.view.BlendMode
import com.soywiz.korge.view.filter.Filter
import com.soywiz.korim.color.ColorAdd
import com.soywiz.korim.color.RGBA
import com.soywiz.korma.geom.Matrix

/**
 * Simple [Filter] that draws the texture pixels without any kind of transformation or smoothing
 */
object IdentityFilterNoSmoothing : Filter {
    override fun render(
        ctx: RenderContext,
        matrix: Matrix,
        texture: Texture,
        texWidth: Int,
        texHeight: Int,
        renderColorAdd: ColorAdd,
        renderColorMul: RGBA,
        blendMode: BlendMode
    ) {
        ctx.batch.drawQuad(
            texture,
            m = matrix,
            filtering = false,
            colorAdd = renderColorAdd,
            colorMul = renderColorMul,
            blendFactors = blendMode.factors,
            program = BatchBuilder2D.getTextureLookupProgram(texture.premultiplied)
        )
    }
}
